import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16.082",
  height: "11.433"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#022b36",
  d: "M1.072 0A1.1 1.1 0 0 0 0 1.107v8.114a1.1 1.1 0 0 0 1.072 1.106h9.923a2.827 2.827 0 0 0 2.228 1.106 2.911 2.911 0 0 0 2.859-2.95 2.986 2.986 0 0 0-1.072-2.3V1.106A1.1 1.1 0 0 0 13.938 0zm0 .738h12.866a.355.355 0 0 1 .357.369v4.639a2.668 2.668 0 0 0-1.474-.179l-1.145-1.049a.36.36 0 0 0-.441-.029L8.6 6.362 5.233 3.406a.364.364 0 0 0-.447-.011L.715 6.628V1.107a.355.355 0 0 1 .357-.369zm7.684.738a1.291 1.291 0 1 0 1.251 1.291 1.277 1.277 0 0 0-1.251-1.291zm0 .738a.553.553 0 1 1-.536.553.539.539 0 0 1 .536-.554zM4.992 4.156l3.356 2.945a.359.359 0 0 0 .43.023l2.63-1.867.609.553a2.964 2.964 0 0 0-1.653 2.674 3.012 3.012 0 0 0 .207 1.106h-9.5a.355.355 0 0 1-.357-.369V7.556l4.277-3.4zm8.231 2.115a2.214 2.214 0 1 1-2.144 2.213 2.174 2.174 0 0 1 2.144-2.214zm.357.922a.351.351 0 0 0-.251.109.373.373 0 0 0 0 .519l.285.294h-1.642a.369.369 0 0 0 0 .738h1.642l-.285.294a.373.373 0 0 0 0 .519.344.344 0 0 0 .5 0c.293-.3.612-.615.882-.916a.358.358 0 0 0 0-.53c-.265-.307-.6-.61-.882-.916a.344.344 0 0 0-.251-.109z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };